module.exports = __webpack_public_path__ + "static/img/bg_02.5aee44b4.png";